import { render, staticRenderFns } from "./GrossingHelpTab.vue?vue&type=template&id=a2026800&"
import script from "./GrossingHelpTab.vue?vue&type=script&lang=js&"
export * from "./GrossingHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports